import React, { useState } from "react";
import { Container, MenuContainer } from "./style";
import { Menu } from "../../../../../projectSpecificComponents/menu";
import { Link } from "react-router-dom";
import { TICKETS } from "../../../../../constants/urls";
import { FAST_TUTORIAL_LINK } from "../../../../../constants/storageKeys";

export default () => {
  const [status, setStatus] = useState(false);
  return (
    <Container>
      <i
        title="راهنما"
        className={
          (status ? "pressed " : "") + "left-side-icon icon mapsa-question"
        }
        onClick={() => setStatus(!status)}
      />
      {status && (
        <Menu showMenu={status} close={() => setStatus(false)}>
          <MenuContainer>
            <li>
              <Link to={TICKETS}>
                <span>پیام به پشتیبانی</span>
              </Link>
            </li>
            <li>
              <a
                href={localStorage.getItem(FAST_TUTORIAL_LINK)}
                target="_blank"
                rel="noopener noreferrer"
              >
                ویدیوهای آموزش سریع
              </a>
            </li>
            <li>
              <a
                href="//tankhahgardan.com/help/web_help.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                دریافت فایل راهنما
              </a>
            </li>
            <li>
              <a
                href="//tankhahgardan.com/help/"
                target="_blank"
                rel="noopener noreferrer"
              >
                راهنما
              </a>
            </li>
          </MenuContainer>
        </Menu>
      )}
    </Container>
  );
};
